import * as React from 'react';

function SvgDarts(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
			<g fill="none" fillRule="evenodd">
				<path d="M4 4h16v16H4z" />
				<path
					fill="currentColor"
					d="M19.973 6.854a.507.507 0 00-.323-.355l-1.68-.485-.484-1.68a.414.414 0 00-.355-.322c-.162-.033-.356 0-.453.129L14.32 6.499c-.129.13-.161.29-.129.484l.485 1.648-.614.614c-.323-.194-.678-.323-1.066-.323-.55 0-1.034.193-1.421.581l-4.749 4.748a1.965 1.965 0 00-.258 2.488L4.145 19.16a.47.47 0 000 .679.49.49 0 00.356.129.486.486 0 00.355-.13l2.423-2.422c.323.194.678.323 1.066.323.549 0 1.033-.194 1.42-.582l4.75-4.748a1.964 1.964 0 00.258-2.487l.613-.614 1.68.485c.032 0 .097.032.13.032a.678.678 0 00.355-.13l2.358-2.357c.064-.162.129-.323.064-.485zm-6.17 4.878L9.056 16.48c-.387.388-1.066.388-1.486 0l-.064-.064a1.034 1.034 0 010-1.486l4.747-4.75c.194-.194.452-.29.743-.29.29 0 .55.096.743.29l.065.065c.387.42.387 1.098 0 1.486zm3.198-2.94l-.872-.258.679-.678a.47.47 0 000-.679.469.469 0 00-.679 0l-.678.679-.258-.873 1.582-1.582.323 1.13c.033.162.162.29.323.323l1.131.323-1.55 1.615z"
				/>
			</g>
		</svg>
	);
}

export default SvgDarts;
